import { Box, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { BankingBankAccountFragment } from 'generated/resources/graphql'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/banking/components/FinishSetupAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/FinishSetupAccountModal/wizardSteps/WizardStepLayout'
import { accountNumberLabel } from 'modules/banking/lib/bankAccountNumbersHelpers'
import CurrencySelector from 'modules/finance/components/CurrencySelector'

interface Props {
  bankAccount: BankingBankAccountFragment
}

export const FinishSetupAliasWizardStep = ({
  data,
  onDataChanged,
  bankAccount,
}: WizardStepRenderParams<WizardData> & Props) => {
  const accountLabel = accountNumberLabel(bankAccount.accountNumberType)

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.finish_wizard.step_1.title_v2')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_1.subtitle_v2')}
    >
      <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s8">
        <TextField
          value={data.accountAlias}
          label={i18n.t('banking.accounts.side_panel.account_alias')}
          placeholder={i18n.t('banking.accounts.side_panel.account_alias')}
          onChange={(newValue) => onDataChanged({ ...data, accountAlias: newValue })}
          autofilled={!!data.accountAlias}
        ></TextField>

        <TextField
          mandatory
          value={bankAccount.accountNumber}
          label={accountLabel}
          placeholder={i18n.t('banking.accounts.side_panel.account_number')}
          readonly
        ></TextField>

        <CurrencySelector
          isDisabled
          currencies={[{ isoCode: bankAccount.currency }]}
          value={bankAccount.currency}
        />
      </Box>
    </WizardStepLayout>
  )
}
